import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const SkipAuditSubscriptionRoutes = defineRoute({
    record: {
        route: {
            path: "/skip-audit-subscription",
            component: () => loadView(import("./SkipAuditSubscriptionTable.vue")),
        },
    },
});
